import { http_client } from "@/plugins/http_client";

const detalleRenuncia = async (params) =>
  await http_client(`/api/solicitudes/renuncia/detalle-renuncia`, params, "get");

const detalleEmpleadoPlaza = async (params) =>
  await http_client(`/api/solicitudes/empleado-plaza-detalle`, params, "get");


const descargarArchivo = async (id_renuncia, tipo_archivo) =>
  await http_client(
    `/api/solicitudes/renuncia/${id_renuncia}/descargar/${tipo_archivo}`, 
    {}, 
    "get", 
    {}, 
    true, 
    "blob"
  );

const visualizarArchivo = async (id_renuncia, tipo_archivo) =>
  await http_client(`/api/solicitudes/renuncia/${id_renuncia}/preview/${tipo_archivo}`, {}, "get");


// Ver acuerdo
const visualizarAcuerdo = async (id_renuncia) =>
  await http_client(`/api/solicitudes/renuncia/get-acuerdo/${id_renuncia}`, {}, "get");
// Ver cálculo indemnización
const visualizarCalculoIndemnizacion = async (id_renuncia) =>
  await http_client(`/api/solicitudes/renuncia/get-calculo-indemnizacion/${id_renuncia}`, {}, "get" );

// -- RRHH
//Simple (2)
const crearAcuerdo = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/rrhh/crear-acuerdo/${id_tramite}`, {}, "post");
//Simple (4) y Voluntaria (5)
const notificarPlanilla = async (id_tramite, params) =>
  await http_client(`/api/solicitudes/renuncia/rrhh/notificar-planilla/${id_tramite}`, params, "post");
//Simple (7) y Voluntaria (8)
const completarProceso = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/rrhh/completar-proceso/${id_tramite}`, {}, "post");
//Voluntaria (2)
const agregarIndemnizacion = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/rrhh/agregar-indemnizacion/${id_tramite}`, {}, "post");
//Voluntaria (3)
const aprobarAcuerdoIndemnizacion = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/rrhh/aprobar-acuerdo-indemnizacion/${id_tramite}`, {}, "post");

// -- Titular
//Simple (3) y Voluntaria (4)
const firmarAcuerdo = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/titular/firmar-acuerdo/${id_tramite}`, {}, "post");
//Simple (3b) y Voluntaria (4b)
const delegarFirmaAcuerdo = async (id_tramite, id_empleado_puesto_delegado) =>
  await http_client(`/api/solicitudes/renuncia/titular/delegar-firma/${id_tramite}`, { id_empleado_puesto_delegado }, "post");
// Listar personas para delegar aprobacion
const obtenerPersonasDelegarAprobacion = async () =>
  await http_client(`/api/solicitudes/renuncia/titular/obtener-delegados`, {}, "get");

// -- Planilla
// Simple (5) y Voluntaria (6)
const confirmarRecepcion = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/planilla/confirmar-recepcion/${id_tramite}`, {}, "post");

// -- UFI
// Simple (6) y Voluntaria (7)
const confirmarSupension = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/ufi/confirmar-suspension/${id_tramite}`, {}, "post");

// -- Jefe unidad
// Simple (1) y Voluntaria (1)
const aprobarRenunciaJefe = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/jefe-unidad/aprobar/${id_tramite}`, {}, "post");
// Simple (1b) y Voluntaria (1b)
const denegarRenunciaJefe = async (id_tramite, params) =>
  await http_client(`/api/solicitudes/renuncia/jefe-unidad/denegar/${id_tramite}`, params, "post");
// Simple (1c) y Voluntaria (1c)
const observarRenunciaJefe = async (id_tramite, params) =>
  await http_client(`/api/solicitudes/renuncia/jefe-unidad/observar/${id_tramite}`, params, "post");

// -- Empleado
// Simple (2c) y Voluntaria (2c)
const subsanarRenunciaEmpleado = async (id_tramite, params) =>
  await http_client(`/api/solicitudes/renuncia/empleado/subsanar/${id_tramite}`, params, "post", { headers: { "content-type": "multipart/form-data" },});
// Simple (3c) y Voluntaria (4c)
const enviarSubsanacion = async (id_tramite) =>
  await http_client(`/api/solicitudes/renuncia/empleado/enviar-subsanacion/${id_tramite}`, {}, "post");


export default {
  detalleRenuncia,  
  detalleEmpleadoPlaza,
  descargarArchivo,
  visualizarArchivo,
  visualizarAcuerdo,
  visualizarCalculoIndemnizacion,
  // RRHH
  crearAcuerdo,
  notificarPlanilla,
  agregarIndemnizacion,
  aprobarAcuerdoIndemnizacion,
  completarProceso,
  // Titular
  firmarAcuerdo,
  obtenerPersonasDelegarAprobacion,
  delegarFirmaAcuerdo,
  // Planilla
  confirmarRecepcion,
  // UFI
  confirmarSupension,
  // Jefe unidad
  aprobarRenunciaJefe,
  denegarRenunciaJefe,
  observarRenunciaJefe,
  // Empleado
  subsanarRenunciaEmpleado,
  enviarSubsanacion,
};